import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Authentication from '../../../../libs/api/services/Authentication'
import PatientProfileOtherRelation from './PatientProfileOtherRelation'
import PatientProfileTeams from './PatientProfileTeams'

export default function PatientProfileRelationships({ patientUserID }) {
    const { id } = useParams()
    const [mode, setMode] = useState((id === Authentication.patientUserID) ? 'Other' : 'Team')

    return (<>
        <div className='d-flex '>
            {(id || !patientUserID) && <button onClick={() => setMode('Team')} className={`w-100 rounded-0 text-center btn ${mode === 'Team' ? 'shadow bg-primary-container' : 'bg-secondary-container'}`}>Clinical Teams</button>}
            {id === Authentication.patientUserID && <button onClick={() => setMode('Other')} className={`w-100 rounded-0 text-center btn ${mode === 'Other' ? 'shadow bg-primary-container' : 'bg-secondary-container'}`}>Other Relationships</button>}
        </div>
        {
            {
                'Team': <PatientProfileTeams PatientId={patientUserID ? patientUserID : Authentication.patientUserID()} />,
                'Other': id === Authentication.patientUserID && <PatientProfileOtherRelation PatientId={patientUserID ? patientUserID : Authentication.patientUserID()} />
            }[mode]
        }
    </>)
}
